var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAskWhyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.6,0C22.5,0,24,1.5,24,3.4v17.1c0,1.9-1.5,3.4-3.4,3.4H3.4C1.5,24,0,22.5,0,20.6V3.4C0,1.5,1.5,0,3.4,0 H20.6z M7.4,7.1L7.4,7.1C7.1,7.9,7.5,8.6,8.1,8.8c0.7,0.2,1.4-0.1,1.6-0.8l0-0.1c0.1-0.2,0.2-0.3,0.4-0.3h3.1 c0.4,0,0.8,0.4,0.8,0.8c0,0.3-0.2,0.6-0.4,0.7l-2.4,1.4c-0.4,0.2-0.6,0.7-0.6,1.1v0.7c0,0.7,0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3 l1.7-1c1-0.6,1.7-1.7,1.7-2.9c0-1.9-1.5-3.4-3.4-3.4h-3.1C8.9,5.1,7.8,5.9,7.4,7.1L7.4,7.1z M12,15.4c-0.9,0-1.7,0.8-1.7,1.7 s0.8,1.7,1.7,1.7s1.7-0.8,1.7-1.7S12.9,15.4,12,15.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAskWhyIcon);
export default __webpack_public_path__ + "static/media/Ask_Why_Icon.593accab5b104f0c2fea2e6eb1aeb0b8.svg";
export { ForwardRef as ReactComponent };